/**
 * Plain ES5: layouts inline this file in `<head>`, so it cannot use modules.
 * A throwing `Sparkle.ready` snippet is passed to `Sparkle.reportBootError(error, origin)`,
 * where `origin` is the template path given as the second argument of `ready`.
 */
(function () {
  window.Sparkle = window.Sparkle || {};
  window.Sparkle.Components = window.Sparkle.Components || {};
  if (window.Sparkle.flushReady) {
    return;
  }

  window.Sparkle._readyQueue = [];
  window.Sparkle.reportBootError = function (error, origin) {
    console.error(error, origin);
  };
  window.Sparkle.ready = function (fn, origin) {
    window.Sparkle._readyQueue.push({ fn: fn, origin: origin });
  };
  function run(fn, origin) {
    try {
      fn();
    } catch (error) {
      window.Sparkle.reportBootError(error, origin);
    }
  }
  window.Sparkle.flushReady = function () {
    var queue = window.Sparkle._readyQueue;
    window.Sparkle._readyQueue = [];
    window.Sparkle.ready = run;
    queue.forEach(function (entry) {
      run(entry.fn, entry.origin);
    });
  };
})();
